// Where the API is, and which version this build of the Hub is written against.
// The version is a request header (Substratal-Version), never part of the URL.
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? "https://api.substratalapps.com";
export const API_VERSION = "1";
